import { Component, Vue, Ref } from "vue-property-decorator";
import InnerBody from './components/InnerBody'
import InnerBodys from './components/InnerBodys'
import CreatModal from './components/CreatModal.vue'
import IndexPrint from '@/components/CodeModel/index.vue'
import EditModal from './components/EditModal.vue'
import { exportMaintainPlan } from '@/api/api'
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { MaintainPlanServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies';

const mpsp = new MaintainPlanServiceProxy()
const dtsp = new DeviceTypeServiceProxy()
@Component({
  components: {
    InnerBody,
    InnerBodys,
    IndexPrint,
    CreatModal,
    EditModal
  }
})
export default class Alarm extends Vue {
  showCode = false
  selectedRows=[]//传给打印的信息
  dataList=[]
  maintainPlanList = []
  ShiftMaterialList = []
  selectedRowKeys = []
  addNewVisible = false
  editVisible = false
  searchKey = ""
  searchStatus = 0
  searchType = ""
  paginationOrder = {
    pageSize: 10,
    current: 1,
  }
  total = 0
  orderLoading = false
  orderMaterialLoading = false
  height = 300
  tableScrollHeight = 300
  selectId = ""
  resizeTimer = null
  deviceTypeList = []
  editData = {}
  isAuto = '-1'

  get planTypes() {
    return [
      {label: this.$t('page_tpm_repair_all'), value: '-1'},
      {label: this.$t('page_material_warehousing_automatic'), value: '1'},
      {label: this.$t('page_plan_maintenance_manual_creation'), value: '0'},
    ]
  }
  mounted() {
    this.$nextTick(() => {
      const search = {
        keyWord:"",
        query:{ current: 1, size:-1}
      } as any
      dtsp.pageDeviceType(search).then(res =>{
        this.deviceTypeList = res.records
        this.getList()
      })
    })
  }
  created(){
  
  }
  updated(){
    const div = document.body.clientHeight
    this.tableScrollHeight = (div - 360) /2
    this.height = (div - 350) /2
  }

  changeY(){
    if(this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function() {
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }
  cancel(){
    this.showCode=false
  }
  print(){
    this.getDataList()
   this.showCode=true
  }
  getList(){
    this.maintainPlanList= []
    this.ShiftMaterialList = []
    this.orderLoading = true
    const deviceType = this.deviceTypeList.find(res => res.code === this.searchType)
    const maintainPlanSearchDTO = {
      deviceId: "",
      deviceTypeId: (deviceType !== undefined ? deviceType.id : ""),
      filterPlus: false,
      keyWord: this.searchKey,
      param: {},
      isAuto: Number(this.isAuto) >= 0 ? Number(this.isAuto): null
    } as any
    mpsp.queryMaintainPlanPage(this.paginationOrder.current,maintainPlanSearchDTO,this.paginationOrder.pageSize).then(res =>{
      this.maintainPlanList = res.records
      console.log(this.maintainPlanList,'kkk')
      if(this.selectId){
        this.onClickRow(this.selectId)
      } else if(res.records && res.records.length > 0){
        this.onClickRow(res.records[0].id)
      }
      this.total = Number(res.total)
      this.orderLoading = false
    }).catch(() =>{this.orderLoading = false})
  }

  reload(){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.editVisible = false
    this.addNewVisible = false
    this.getList()
  }
  getDataList() {
    this.selectedRows = []
    this.selectedRowKeys.map(id =>{
      this.maintainPlanList.map(item => {
        if(id === item.id) {
          this.selectedRows.push({
            code: item.code,
            name: item.deviceName
          })
        }
      })
    })
  }
  onSearch(value) {
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.searchKey = value
    this.getList()
  }

  handleChangeType(value, type){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this[type] = value
    this.getList()
  }

  addNew(){
    this.addNewVisible = true
  }

  addClose() {
    this.addNewVisible = false
  }

  editClose() {
    this.editVisible = false
  }

  edit(value) {
    this.editData = value
    this.editVisible = true
  }

  implement(value){
    mpsp.performMaintainPlan(value.id).then(() =>{
      this.$message.success(this.$t('page_plan_maintenance_successful_execution'))
      this.getList()
    })
  }
  onSelectChange(selectedRowKeys,selectedRows) {
    this.selectedRows=selectedRows
    this.selectedRowKeys = selectedRowKeys;
    if(selectedRowKeys.length == 1 ){
      this.onClickRow(selectedRowKeys[0])
    }
  }

  handleTableChange(data) {

    this.paginationOrder = {
      pageSize: data.pageSize,
      current: data.current
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.getList()
  }

  onClickRow(value){
    this.selectId = value
    this.selectedRowKeys = [value]
    this.orderMaterialLoading = true
    mpsp.getMaintainPlan(value).then(res =>{
      this.ShiftMaterialList = res.maintainPlanItemVoList
      this.orderMaterialLoading = false
    })
  }

  beforeDestroy(){
    clearTimeout(this.resizeTimer)
    this.resizeTimer = null
  }

  delete(){
    mpsp.deleteMaintainPlan(this.selectedRowKeys).then(() =>{
      this.$message.success(this.$t('delete_success'))
      this.reload()
    })
  }

  handleMenuClick(value){
    const deviceType = this.deviceTypeList.find(res => res.code === this.searchType)
    const data = {
      deviceId: "",
      deviceTypeId: (deviceType !== undefined ? deviceType.id : ""),
      exportSelected: true,
      keyWord: this.searchKey,
      selectedRecords: []
    }
    if(value == 1){
      data.exportSelected = true
      data.selectedRecords = this.selectedRowKeys
    } else {
      data.exportSelected = false
      data.selectedRecords = []
    }
    exportMaintainPlan(data).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_equipment_maintenance_plan')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button v-acl="page_maintenance_plan_add_new_plan" type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_plan_maintenance_add_maintenance_plan')}</a-button>
            <a-popconfirm
              title={this.$t("page_resource_pool_confirm_delete")}
              onConfirm={() => this.delete()}
              okText={this.$t("yes")}
              cancelText={this.$t("no")}
            >
              <a-button type="danger" v-acl="page_maintenance_plan_delete_plan" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{ this.$t('delete')}</a-button>
            </a-popconfirm>
            <a-dropdown>
              <a-menu slot="overlay" onClick={value => this.handleMenuClick(value.key)}>
                <a-menu-item key={1} disabled={this.selectedRowKeys.length === 0}>
                  { this.$t('page_product_confirm_select_export') }
                </a-menu-item>
                <a-menu-item key={2} disabled={this.maintainPlanList.length === 0}>
                  { this.$t('page_product_confirm_search_export') }
                </a-menu-item>
              </a-menu>
              <a-button v-acl="page_maintenance_plan_export_plan" style="margin-right: 8px;">{ this.$t('page_product_export')}<a-icon type="down" /> </a-button>

            </a-dropdown>
          <a-button v-acl="page_maintenance_plan_export_plan" onClick={()=>this.print()} disabled={this.selectedRowKeys.length === 0}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
            <app-select showSearch ={true} list={this.planTypes} v-model={this.isAuto} onChangeSelect={value=>this.handleChangeType(value, 'isAuto')} style="width:120px;"/>

            <a-select 
            showSearch ={true}
            optionFilterProp="children"
            value={this.searchType} placeholder={ this.$t('page_business_device_type') } style="width: 120px;margin-right: 8px;" onChange={value => this.handleChangeType(value, 'searchType')}>
              <a-select-option value={""}>
                { this.$t('page_plan_maintenance_all_types') }
              </a-select-option>
              { this.deviceTypeList.map(item => {
                return <a-select-option value={ item.code } >
                        { item.name }
                      </a-select-option>
              })}
            </a-select>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px"  enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <div id="ware-topmodal" style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-body
              height={this.tableScrollHeight}
              selectId={this.selectId}
              selectedRowKeys={this.selectedRowKeys}
              data={this.maintainPlanList}
              current={this.paginationOrder.current}
              total={this.total}
              loading={this.orderLoading}
              pageSize={this.paginationOrder.pageSize}
              onOnSelectChange={(value,values) => this.onSelectChange(value,values) }
              onHandleTableChange={value => this.handleTableChange(value) }
              onClickRow={value => this.onClickRow(value)}
              onImplement={value => this.implement(value)}
              onEdit={value => this.edit(value)}
              onReload={() => this.reload()}
            ></inner-body>
          </div>
          <div v-resize={{axis: 'y', cb: this.changeY }}></div>
          <div style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-bodys
              height={this.height}
              data={this.ShiftMaterialList}
              loading={this.orderMaterialLoading}
            ></inner-bodys>
          </div>
        </div>
        {<index-print
          visible={this.showCode}
          dataList={this.selectedRows}
          onPrint={()=>this.print()}
          onCancel={()=>this.cancel()}
           ></index-print>
        }
        {this.addNewVisible ? <creat-modal
          visible={this.addNewVisible}
          onClose={() => this.addClose()}
          onReload={() => this.reload()}></creat-modal> : null }
        {this.editVisible ? <edit-modal
          visible={this.editVisible}
          editData={this.editData}
          onClose={() => this.editClose()}
          onReload={() => this.reload()}></edit-modal> : null }

      </blank-view>
    )
  }
}
